export default {
  state: {
    userTable: [
      {
        isShow: true,
        name: 'userID'
      },
      {
        isShow: true,
        name: 'brandCodes'
      },
      {
        isShow: true,
        name: 'GWMcompany'
      },
      {
        isShow: true,
        name: 'dotType'
      },
      {
        isShow: true,
        name: 'position'
      },
      {
        isShow: true,
        name: 'role'
      },
      {
        isShow: true,
        name: 'mobile'
      },
      {
        isShow: true,
        name: 'Incumbency'
      },
      {
        isShow: true,
        name: 'userEmail'
      },
      {
        isShow: true,
        name: 'education'
      },
      {
        isShow: true,
        name: 'buildmen'
      },
      {
        isShow: true,
        name: 'lastlogintime'
      },
      {
        isShow: true,
        name: 'accessionDate'
      },
      {
        isShow: true,
        name: 'leaveDate'
      }
    ]
  }
}
